// src/styles/components/MuiChip.js

const MuiChip = {
  styleOverrides: {
    root: {
      fontSize: "0.875rem",
      fontWeight: 600,
      textTransform: 'capitalize', // Prevents automatic capitalization
    },
    icon: {
      color: 'inherit',
    },
    label: {
      paddingLeft: 12,
      paddingRight: 12,
    },
  },

  variants: [
    {
      props: { color: 'primary', variant: 'filled' },
      style: {
        backgroundColor: 'primary.main',
        color: 'primary.contrastText',
        textTransform: 'capitalize',
      },
    },
    {
      props: { color: 'primary', variant: 'outlined' },
      style: {
        backgroundColor: 'primary.alpha20',
        color: 'primary.light',
        border: 1,
        borderColor: 'divider',
        textTransform: 'capitalize',
        '&:hover': {
          backgroundColor: 'primary.alpha20',
        },
      },
    },
  ],

  defaultProps: {
    size: 'small',
    variant: 'outlined',
  },
};

export default MuiChip;